import { render, staticRenderFns } from "./newsletter-importer-page.vue?vue&type=template&id=87395066&"
import script from "./newsletter-importer-page.vue?vue&type=script&lang=js&"
export * from "./newsletter-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports